<template>
  <div style="background:#F4F5F9">
    <topPart :rightPart="true"></topPart>
    <!-- 签名 -->
    <div v-show="test" class="sign" style="position:fixed;top:0;z-index:9999;bottom:0">
      <signature @closePop="closePop" @saveImg="complete"></signature>
    </div>
    <!-- 签名结束 -->

    <!-- 标题 -->
    <div class="list-block">
      <div class="list_block_title">
        <div class="title-box1">
          <div class="titleStyle">提案</div>
          <div class="nameStyle">{{title}}</div>
        </div>
      </div>
      <div class="list_block_ctn">
        <!-- <handleText :data="content" :maxLen="100"></handleText> -->
        <!-- <handleContent :content="content"></handleContent> -->
        <div ref="content" v-html="content" :class="[showBtn?'content-close':'content-open']"></div>
        <div class="zkBox" v-if="isShow">
          <span class="btnWord" @click="showBtn=!showBtn">{{showBtn?"展开":"收起"}}</span>
          <span
            :class="['iconfont', !showBtn?'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-6':'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-7']"
          ></span>
        </div>
        <div class="enclosureBox">
          <div class="box_left">
            <img class="qbz-icon" src="../../../assets/images/qbz_icon.png" />附件：
          </div>
          <div class="enclosureConter">
            <div v-for="(item,index) in fileList" :key="index" @click="fileOpenFn(item)">
              <div class="van-ellipsis">
                <a>{{item.fileName}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dealine_date">截止日期：{{time}}</div>
    </div>
    <!-- 标题结束 -->

    <!-- 逻辑操作 -->
    <div v-show="!test">
      <div v-if="forTheFirstTime == 0">
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          label-width="80px !important"
          style="height: 100%;overflow: scroll;"
        >
          <!-- 我的提案 -->
          <div class="proposal_ctn">
            <div class="title_second">
              <span></span>我的提案
            </div>
            <div>
              <el-form-item label="案由" prop="causeOfAction" class="form-item"></el-form-item>
              <van-field
                v-model="causeOfAction"
                rows="4"
                autosize
                type="textarea"
                maxlength="1000"
                placeholder="请输入案由，字数在1000字以内"
                show-word-limit
                class="texts"
              />
            </div>
            <div>
              <el-form-item label="案据" prop="causeOfAction" class="form-item"></el-form-item>
              <van-field
                v-model="accordingToInformation"
                rows="4"
                autosize
                type="textarea"
                maxlength="1000"
                placeholder="请输入案据，字数在1000字以内"
                show-word-limit
                class="texts"
              />
            </div>
            <div>
              <el-form-item label="方案" prop="causeOfAction" class="form-item"></el-form-item>
              <van-field
                v-model="programme"
                rows="4"
                autosize
                type="textarea"
                maxlength="1000"
                placeholder="请输入方案，字数在1000字以内"
                show-word-limit
                class="texts"
              />
            </div>
          </div>
          <!-- 我的提案 结束-->
        </el-form>
        <div class="proposal_title_32">
          <div>附议代表（{{num}}人)</div>
          <div @click="addPersonnel">
            <span>发送请求</span>
            <img src="@/images/send_img.png" alt />
          </div>
        </div>
        <!-- 附议代表签名 -->
        <div
          v-for="(item,index) in arr"
          :key="index"
          :class="item.statusp != '1'?'sign_list':'sign_list sign_height'"
        >
          <div class="sign_title">代表签名</div>
          <div class="boxtextdel" v-if="item.statusp != '1'">
            <div class="sign_title_empty">等待{{item.staffName}}签名</div>
            <div>
              <button @click="deleteSecondedRepresentative(item)" class="delButton">删除</button>
            </div>
          </div>
          <div v-else class="photoStyle">
            <img :src="item.signatrue" />
          </div>
        </div>
        <!-- 附议代表签名结束 -->
        <!-- 签名 -->
        <div v-if="sign == 1" class="my_flex">
          <div class="sign_title">我的签名</div>
          <div v-if="imgData" class="resign">
            <img class="sign-img" :src="imgData" />
            <span @click="showPopup" class="resign-txt">重新签名</span>
          </div>
          <div v-else class="signature_edit" @click="showPopup">
            <div>
              <img src="@/images/edit.png" alt />
              <span class="no_singature">签名</span>
            </div>
          </div>
        </div>
        <!-- 签名结束 -->
        <!-- 展示签名结束 -->
        <!-- 保存按钮 -->
        <button class="submit_btn" @click="saveData()">保存</button>
        <button class="submit_btn" @click="submit">提交</button>
        <!-- 保存按钮结束 -->
      </div>

      <div v-else>
        <div class="proposal_ctn">
          <div class="title_second">
            <span></span>我的提案
          </div>
          <div>
            <div class="title_third">案由</div>
            <div class="ctn_third">{{causeOfAction}}</div>
          </div>
          <div>
            <div class="title_third">案据</div>
            <div class="ctn_third">{{accordingToInformation}}</div>
          </div>
          <div>
            <div class="title_third">方案</div>
            <div class="ctn_third">{{programme}}</div>
          </div>
        </div>

        <div class="proposal_title_32">
          <div>附议代表（{{num}}人)</div>
          <div @click="addPersonnel">
            <span>发送请求</span>
            <img src="@/images/send_img.png" alt />
          </div>
        </div>

        <!-- 签名 -->
        <div v-if="sign == 1" class="my_flex">
          <div class="sign_title">我的签名</div>
          <div v-if="imgData" class="resign">
            <img class="sign-img" :src="imgData" />
          </div>
        </div>
        <!-- 签名结束 -->

        <div
          v-for="(item,index) in arr"
          :key="index"
          :class="item.statusp != '1'?'sign_list':'sign_list sign_height'"
        >
          <div class="sign_title">代表签名</div>
          <div v-if="item.statusp != '1'">
            <div class="sign_title_empty">等待{{item.staffName}}签名</div>
          </div>
          <div v-else class="photoStyle">
            <img :src="item.signatrue" />
          </div>
        </div>
        <!-- <button class="submit_btn" :disabled="submitStatus" @click="submit">提交</button> -->

        <!-- 详情结束 -->
      </div>
    </div>
    <!-- 逻辑操作结束 -->
    <!-- 打开文件弹框 -->
    <van-popup
      :lock-scroll="true"
      v-model="openFileShow"
      round
      position="bottom"
      :style="{ height: '160px' }"
    >
      <div class="open_file">
        <div @click="openFileFn">打开文档</div>
        <div @click="copyOpen">复制下载链接</div>
        <div class="open_cancel" @click="cancelOpen">取消</div>
      </div>
    </van-popup>
    <!-- 打开文件弹框 结束-->
  </div>
</template>

<script>
import topPart from "../../../components/topPart";
import moment from "moment";
import { toast } from "@/common/api/api.js";
import signature from "../../../components/signature.vue";
// import handleText from "../../../components/handleText";
// import handleContent from "../../../components/handleContent";
export default {
  components: {
    topPart,
    signature,
    // handleContent
  },
  data() {
    return {
      showBtn: false,
      isShow: false,
      innerText: "",
      form: {},
      rules: this.centralControl.check.getCheckConfig("solicitingProposals"),
      num: 0,
      sendType: "",
      isSignature: "",
      submitStatus: true,
      sign: "",
      arr: [], //签名列表
      accordingToInformation: "", //案据
      programme: "", //方案
      causeOfAction: "", //案由
      forTheFirstTime: "",
      imgData: "", //签名
      test: false,
      conter: "", //意见盒子
      id: this.$route.query.id,
      recordId: "",
      time: "",
      fileList: [],
      title: "",
      content: "",
      openFileShow: false,
      currentFile: {}
    };
  },
  mounted() {
    //获取详情数据
    this.getDetails();
  },
  methods: {
    handleContent() {
      this.$nextTick(() => {
        console.log(this.$refs.content.offsetHeight, "535324523");
        if (this.$refs.content.offsetHeight > 30) {
          this.showBtn = true;
          this.isShow = true;
        } else {
          this.showBtn = false;
        }
      });
    },
    //删除附议代表回调
    deleteSecondedRepresentativeFun(obj) {
      this.getDetails();
    },
    //删除附议代表
    deleteSecondedRepresentative(item) {
      var obj = {
        id: item.id
      };
      this.sendQuestion(
        "deleteInviteProposal",
        obj,
        "deleteSecondedRepresentativeFun"
      );
    },
    // 打开弹框
    fileOpenFn(item) {
      this.currentFile = item;
      this.openFileShow = true;
    },
    // 关闭弹框
    cancelOpen() {
      this.openFileShow = false;
    },
    // 复制
    copyOpen() {
      if (!this.currentFile.filePath) return;
      window.scrollTo(0, 0);
      let that = this;
      let aux = document.createElement("input");
      aux.setAttribute("value", this.currentFile.filePath);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      aux.className = "aux";
      aux.style.display = "none";
      document.body.removeChild(aux);
      setTimeout(() => {
        toast(that, "复制成功", "success");
      }, 800);
      this.cancelOpen();
    },
    // 打开文件
    openFileFn() {
      if (!this.currentFile.filePath) return;
      window.location.href = this.currentFile.filePath;
      this.cancelOpen();
    },
    submitFun(data, message) {
      toast(this, message, "success");
      setTimeout(() => {
        this.$router.go(-1);
      }, 2000);
    },
    getSubmitData() {
      var obj = {
        id: this.recordId,
        proposalId: this.id
      };
      return obj;
    },
    //提交函数
    submit(data, message) {
      if (this.submitStatus) {
        toast(this, "附议代表未签名完成，无法提交！", "error");
        return;
      }
      var obj = this.getSubmitData();
      this.sendQuestion("submitProposal", obj, "submitFun");
    },
    getImgData() {
      if (this.imgData) {
        return this.imgData.includes("http") ? "" : this.imgData;
      } else {
        return "";
      }
    },
    getSaveData() {
      var obj = {
        proposalId: this.id,
        id: this.recordId,
        recordSignature: this.getImgData(),
        reason: this.causeOfAction,
        evidence: this.accordingToInformation,
        proposal: this.programme
      };
      return obj;
    },
    saveDataFun(data, message) {
      toast(this, message, "success");
    },
    //保存数据
    saveData(str = "saveDataFun") {
      var obj = this.getSaveData();
      this.sendQuestion("saveProposal", obj, str);
    },
    complete(data) {
      if (data) {
        this.imgData = data;
        this.test = false;
      }
    },
    closePop() {
      this.test = false;
    },
    showPopup() {
      this.test = !this.test;
    },
    addPersonnelFun() {
      if (this.num > this.arr.length) {
        this.$router.push({
          path: "/personnel",
          query: {
            id: this.id,
            sendType: this.sendType,
            recordId: this.recordId
          }
        });
      } else {
        toast(this, "附议代表不能超过" + this.num + "人", "error");
      }
    },
    //打开人员弹出层
    addPersonnel() {
      //保存数据
      this.saveData("addPersonnelFun");
      //跳转页面
      this.addPersonnelFun();
    },
    getTitleType(type) {
      return this.typeConfig[type].title;
    },
    //获取详情参数
    getgetDetailsData() {
      var obj = {
        proposalId: this.id
      };
      return obj;
    },
    //提交按钮展示
    statusTransfrpm() {
      var flag = false;
      if (this.num != this.arr.length) {
        flag = true;
      } else {
        for (var a = 0; a < this.arr.length; a++) {
          if (this.arr[a].statusp == "0") {
            flag = true;
            break;
          }
        }
      }
      this.submitStatus = flag;
    },
    //赋值 提案数据
    objTransfrom(obj, item) {
      this.imgData = obj.recordSignature; //签名
      this.programme = obj.proposal; //方案
      this.causeOfAction = obj.reason; //案由
      this.accordingToInformation = obj.evidence; //案据
      this.num = item.auditNum; //附议人数
    },
    //处理返回数据
    getDetailsFun(data, message) {
      this.sign = data.proposal.isSignature; //是否签名
      this.forTheFirstTime = data.record.statusp; //提交状态
      this.recordId = data.record.id; //提交ID
      this.sendType = data.proposal.sendType;
      this.isSignature = data.proposal.isSignature;
      this.arr = data.signatures; //签名列表
      //赋值图片
      this.fileList = data.demoraticFiles;
      //策略转换数据
      this.title = data.proposal.title; //赋值title
      this.content = data.proposal.content; //赋值内容content
      this.time = moment(data.proposal.endTime).format("YYYY-MM-DD HH:mm:ss"); //结束时间
      //内容转换
      this.objTransfrom(data.record, data.proposal);
      //提交按钮转换
      this.statusTransfrpm();
      this.handleContent();
    },
    //获取详情数据
    getDetails() {
      var obj = this.getgetDetailsData();
      this.sendQuestion("proposalAndSignatureDetail", obj, "getDetailsFun");
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        res => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this[fun](data, message);
          } else {
            toast(this, message, "error");
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    }
  }
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
.zkBox {
   float: right;
    color: #29bdbb;
     font-size: 14px;
}
/deep/ .texts.van-cell{
  // min-height:136px !important;
  // max-height:528px !important;
  // overflow-y:auto !important;
  -webkit-overflow-scrolling: touch;
  /deep/ .van-field__control{
    min-height:130px !important;
    max-height:500px !important;
    overflow-y:scroll;
    -webkit-overflow-y: scroll;

  }
}
.content-open {
  // height: 4.15rem;
  // overflow-y: scroll;
  word-break:break-all;
}

.content-close {
  overflow: hidden;
  // text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  >>>p,ol, span, ol, li, ul, h1, h2, strong, em {
     overflow: hidden;
  }
}

.boxtextdel {
  flex: 2;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.delButton {
  font-size: 14px;
  color: #29bebc;
  width: 35px;
  margin-right: 0px;
  background: #fff;
}

.resign-txt {
  font-style: normal;
  margin: auto 0;
  text-align: center;
}

.resign {
  flex: 1;
  text-align: center;
  display: flex;
}

.sign-img {
  // width: 60px;
  height: 60px;
  margin: auto;
}

.open_file {
  height: 100%;
  background: #F3F5F9;

  #copyBtn {
    cursor: pointer;
  }

  div {
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #FFF;
  }

  >div:nth-child(1) {
    border-bottom: 1px solid #EFEFF3;
  }

  .open_cancel {
    margin-top: 9px;
  }
}

.enclosureConter {
  flex: 1;
  min-width: 0;

  >div {
    line-height: 34px;
    border-bottom: 1px solid #EFEFF3;
  }

  >div:nth-last-child(1) {
    border: none;
  }

  a {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(86, 137, 240, 1);
  }
}

.box_left {
  line-height: 30px;
}

.enclosureBox {
  display: flex;
  margin-top: 10px;
  align-items: center;
}

.enclosureTitle {
}

.qbz-icon {
  width: 14px;
  height: 15px;
  margin-right: 5px;
}

.photoStyle {
  width: 44px;
  height: 130px;
  transform: rotate(90deg);
  transform-origin: 62px 56px;
  margin-left: 40px;

  img {
    // width: 100%;
    height: 1.5rem;
  }
}

.title-box1 {
  display: flex;
}

.titleStyle {
  padding: 4px 7px;
  border-radius: 20px;
  font-size: 11px;
  color: #fff;
  text-align: center;
  display: inline-block;
  margin: auto 10px auto 0;
  background: linear-gradient(103deg, rgba(79, 172, 254, 1), rgba(0, 242, 254, 1));
}

.nameStyle {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(53, 53, 53, 1);
  line-height: 22px;
  min-width: 0;
  flex: 1;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 22px;
}

.list-block {
  background: #FFF;
  margin-top: 50px;
  height: auto !important;

  .list_block_title {
    padding: 16px;
    border-bottom: 1px solid #EFEFF4;
  }

  .list_block_ctn {
    padding: 16px;
  }
}

.conterStyle {
  // padding: 0 10px 10px 10px;
  >>> img {
    max-width: 100%;
    margin-top: 4px;
  }

  >>> p, span {
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }

  >>> p:nth-child(1) {
    margin-top: 0;
  }

  >>> ol, span, ol, li, ul, h1, h2, strong, em {
    display: inline-block;
  }

  >>> br {
    display: none;
  }
}

.dealine_date {
  width: 100%;
  height: 36px;
  background: rgba(255, 75, 75, 0.1);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FF4B4B;
  text-align: center;
  line-height: 36px;
}

.suggest_color {
  background: linear-gradient(103deg, rgba(69, 209, 172, 1), rgba(39, 189, 186, 1));
}

.vote_color {
  background: linear-gradient(103deg, rgba(255, 19, 86, 1), rgba(255, 59, 142, 1), rgba(255, 19, 86, 1));
}

.proposal_ctn {
  padding: 16px;
  background: #FFF;
  margin-top: 10px;

  .title_second {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    position: relative;
    border-bottom: 1px solid #EFEFF3;
    padding-bottom: 16px;

    span {
      display: inline-block;
      width: 7px;
      height: 7px;
      background: #29BDBB;
      margin-right: 4px;
    }
  }

  .title_third {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    padding: 18px 0 10px 0;
  }

  .ctn_third {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(135, 135, 135, 1);
    line-height: 20px;
    max-height: 150px;
    overflow-y: auto;
    word-break:break-all;
  }
}

>>> .van-cell {
  padding: 10px;
  background: rgba(243, 245, 249, 1);
  border-radius: 10px;
}

>>> .van-field__word-limit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(135, 135, 135, 1);
}

.submit_btn {
  width: 39%;
  display: inline-block;
  // border: 1px solid rgba(41, 189, 187, 1);
  border-radius: 10px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  height: 44px;
  margin: 20px;
  line-height: 44px;
  background: #38C7C4;
}

.proposal_title_3 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  border-bottom: 1px solid #EFEFF3;
  padding: 20px;
  background: #FFF;
  margin-top: 10px;
}

.proposal_title_32 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  border-bottom: 1px solid #EFEFF3;
  padding: 16px 20px;
  background: #FFF;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(41, 189, 187, 1);
    margin-right: 10px;
  }

  img {
    width: 22px;
  }
}

.my_flex {
  display: flex;
  align-items: center;
  background: #FFF;
  padding: 16px;
  justify-content: space-between;

  .sign_title {
    flex: 1;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }
}

.signature_edit {
  width: 252px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(41, 190, 188, 1);

  .no_singature {
    display: inline-block;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(41, 190, 188, 1);
    line-height: 22px;
  }

  img {
    width: 16px;
    margin-right: 4px;
  }
}

.sign_list {
  display: flex;
  padding: 26px 16px;
  background: #FFF;
  border-bottom: 1px solid #EFEFF3;

  .sign_title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }

  .sign_title_empty {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 75, 75, 1);
    margin-left: 40px;
  }

  >div:nth-child(2) {
    // margin-left: 40px;
  }
}

.sign_height {
  height: 30px;
}
</style>